// @owma/common-web/utils/svgHelper — SVG loader 헬퍼.
// 출처: apps/owma/src/utils/svgHelper/index.tsx (앱 전용 의존 없음 — 전체 이동).
import React, { useEffect, useState } from 'react'
import parse from 'html-react-parser'

interface SvgCacheInfo {
  isLoading: boolean
  isLoaded: boolean
  elem: React.ReactElement | null
  waitingReq: Array<{
    resolve: (elem: React.ReactElement) => void
    reject: (err: any) => void
  }>
  error?: any
}

interface RoleImageMap {
  [key: string]: SvgCacheInfo
}

export type PreProcessor = (code: string) => string

export const preProcessorCurrentColor = (code: string): string => {
  return code.replace(
    /(stroke|fill)=((\"(?!none)(.{3,8})\")|(\'(?!none)(.{3,8})\'))/gi,
    '$1="currentColor"',
  )
}

const roleImageMap: RoleImageMap = {}

export function svgLoader(src: string, preProcessor?: PreProcessor): Promise<React.ReactElement> {
  if (roleImageMap[src] == null) {
    roleImageMap[src] = {
      isLoading: false,
      isLoaded: false,
      elem: null,
      waitingReq: [],
    }
  }

  const info = roleImageMap[src]

  return new Promise((resolve, reject) => {
    if (info.isLoading === true) {
      info.waitingReq.push({ resolve, reject })
      return
    } else if (info.isLoaded !== true) {
      info.isLoading = true
      var request = new XMLHttpRequest()
      request.open('GET', src, true)
      request.onload = function () {
        if (this.status == 200) {
          let text = this.response
          if (preProcessor != null) {
            text = preProcessor(text)
          }
          const elem = parse(text) as React.ReactElement
          roleImageMap[src].elem = elem
          resolve(elem)

          info.waitingReq.forEach((promise) => {
            promise.resolve(elem)
          })
          info.waitingReq = []
          info.isLoading = false
          info.isLoaded = true
        }
      }
      request.onerror = function (err) {
        console.log('onerror ', err)
        roleImageMap[src].error = err
        reject(err)

        info.waitingReq.forEach((promise) => {
          promise.reject(err)
        })
        info.waitingReq = []
        info.isLoading = false
        info.isLoaded = true
      }
      request.send()
    } else {
      if (info.elem != null) {
        resolve(info.elem)
      } else {
        reject(info.error)
      }
    }
  })
}

export interface SVGImageProps {
  src: string
  preProcessor?: PreProcessor
  [key: string]: any
}

export function SVGImage(props: SVGImageProps): React.ReactElement | null {
  const { src, preProcessor } = props
  const [svgElem, setSvgElem] = useState<React.ReactElement | null>(
    roleImageMap[src] != null && roleImageMap[src].isLoaded === true
      ? roleImageMap[src].elem
      : null,
  )

  useEffect(() => {
    if (roleImageMap[src] == null || roleImageMap[src].isLoaded === false) {
      svgLoader(src, preProcessor)
        .then((elem) => {
          setSvgElem(elem)
        })
        .catch((err) => {
          console.log('svgLoader error ', err)
        })
    }
  }, [src])

  return svgElem
}

export function SVGImageCurrentColor(props: SVGImageProps): React.ReactElement | null {
  return <SVGImage preProcessor={preProcessorCurrentColor} {...props} />
}
